import ThisModule from "./StepChooseSessionDuration";

export default ThisModule;
